import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Initial Data Resolver
 * ✅ Loads navigation and other data with graceful error handling
 * ✅ Waits for authentication to complete before loading navigation
 */
export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);

    // ✅ Fork join with graceful error handling for each service
    // Removed delay - unnecessary, state propagates immediately
    return forkJoin([
        navigationService.get().pipe(
            catchError((error) => {
                // Return empty navigation on error (non-blocking)
                return of({ compact: [], default: [], futuristic: [], horizontal: [] });
            })
        ),
        messagesService.getAll().pipe(
            catchError(() => of([]))
        ),
        notificationsService.getAll().pipe(
            catchError(() => of([]))
        ),
        quickChatService.getChats().pipe(
            catchError(() => of([]))
        ),
        shortcutsService.getAll().pipe(
            catchError(() => of([]))
        ),
    ]).pipe(
        catchError((error) => {
            // Return empty data instead of blocking app load
            return of([
                { compact: [], default: [], futuristic: [], horizontal: [] },
                [],
                [],
                [],
                []
            ]);
        })
    );
};
